import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffPurchaseRemits = () => import('./staff/purchaseRemits')

Vue.use(Router)

const router =
  [
    {
      path: '/st/purchase-remits',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'PurchaseRemitsStaffDashboard',
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Remitos de compras',
          }          
        },   
        {
          path: 'remits',
          name: 'PurchaseStaffPurchaseRemits',
          component: ViewStaffPurchaseRemits,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de remitos de compras',
          }          
        },             
      ]
    },

    {
      path: '/cu/purchase-remits',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/purchase-remits',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
